import { t } from '@lingui/core/macro'

import { getDisplayMessage } from '../../../components/api/displayMessage'
import type { RequestError } from '../../../components/api/extractHttpError'

export const getSummaryErrorToast = (
  error?: RequestError | null,
): { title: string; description: string } => {
  if (error?.cause?.status === 422)
    return {
      title: t`Unprocessable summary`,
      description: getDisplayMessage(
        error,
        t`Unable to process the summary. Please adjust your input and try again.`,
      ),
    }

  return {
    title: t`An error occurred while processing the summary`,
    description: getDisplayMessage(error),
  }
}
